import React from 'react'
import { useState } from 'react';
// import { Link } from "gatsby";
import { render } from "storyblok-rich-text-react-renderer"
import { sbEditable } from "@storyblok/storyblok-editable";


const BenefitsTab = ({ blok }) => {
    // console.log(blok)

    const activeTabStyle = {
        color: "white",
        backgroundColor: "DodgerBlue",
        padding: "10px",
        fontFamily: "Arial"
    };

    const [activeTab, setActiveTab] = useState(-1)
    const [activeTabDisplay, setActiveTabDisplay] = useState(-1)

    const tabMenu = blok.program_list.map((item, i) =>
        <button
            className={`${activeTab == i ? "is-active" : ""} button`}
            key={i}
            onClick={() => { setActiveTabDisplay(i); setActiveTab(i) }}
        >

            <span>{item.name}</span>

        </button>
    )

    const tabContent = blok.program_list.map((item, i) =>
        <div
            className=""
            value={i}
            key={i}
            style={activeTabDisplay == i ? { display: 'block' } : { display: 'none' }}
        >
            {item.programs_list.map((item, i) =>
                <div
                    className='pb-6'
                    key={i}

                >

                    <h3 className='title is-4'>{item.name}</h3>
                    <hr></hr>
                    <div className="content">{render(item.description)}</div>
                </div>)}
        </div>
    )

    // const tabContent = blok.program_list.map((item, i) =>
    //     <div
    //         className="notification content has-background-white"
    //         value={i}
    //         // style={listDisplay == i ? { display: 'block' } : { display: 'none' }}
    //     >
    //         {render(item.description)}
    //     </div>
    // )

    return (
        <div {...sbEditable(blok)}>

            <div className="section" style={{ backgroundColor: "#FFF" }}>
                <div className="container" >
                    <h1
                        className="is-size-3 label has-text-centered"
                    >
                        {blok.title}
                    </h1>
                    <p className="has-text-centered pb-6">Click on the buttons to see the programs for each benefit</p>
                    <div className="columns is-vcentered">
                        <div className="column is-full is-size-5">
                            <div className="buttons is-centered is-medium"
                            // style={{ backgroundColor: "#C9E3E0" }}

                            >

                                {tabMenu}

                            </div>
                            <div
                                className='notification selfservice-notification has-text-black'
                                style={activeTabDisplay != -1 ? { display: 'block' } : { display: 'none' }}
                            // style={{ backgroundColor: "#C9E3E0", height: "500px", overflowY: "scroll" }}
                            >
                                {tabContent}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BenefitsTab;